<div class="flex flex-col min-h-screen">
  <app-header-app></app-header-app>

  <main class="pt-16 flex-grow flex flex-col">
    <router-outlet></router-outlet>
  </main>

  <app-footer-app></app-footer-app>
</div>
